export const currenciesColumns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'name',
    label: 'Currency',
  },
  {
    name: 'description',
    label: 'Description',
  },
  {
    name: 'decimals',
    label: 'Current balance',
  },
];

export const currenciesColumnsLabels = {};

export const currenciesDefaultSorter = {};

export const currenciesSchema = {};
